<template>
  <div id='header-menu' :class="{ 'dont_print': store.state.customer.printing }">
    <!-- Navbar for PC and larger screen -->
    <div class="container d-flex">


      <div class="d-flex align-items-center col-2">
        <a href="/">
          <img src="/favicon.png" class="main_webpage_logo" alt="Logo">
        </a>
      </div>
      <div class="d-flex justify-content-end col-10">
        <nav class="navbar navbar-expand-lg pt-0 pb-0 container__tablet-screen">

          <div class="collapse navbar-collapse">
            <ul class="navbar-nav justify-content-xl-end w-100">
              <HeaderMenuChildComponent v-for="mainNode in menuData" :key="mainNode.id" :main-node="mainNode" />
            </ul>
          </div>

          <div class="w-100">
            <div class="container d-flex flex-row justify-content-between align-items-center">
              <ButtonComponent @click="toggleMeniu" v-show="toggle" class="navbar-toggler mob-navbar-toggler"
                type="button">
                <template #btnContent>
                  <span class="mob-navbar-icon"></span>
                </template>
              </ButtonComponent>
            </div>

            <div :class="isOpen ? 'container__meniu-mob-left container__meniu-mob-left__animation d-lg-none' : null">
              <ul class="navbar-nav" v-show="isOpen">
                <li class="d-flex w-100 justify-content-end">
                  <ButtonComponent @click="toggleMeniu" class="mob-close-button">
                    <template #btnContent>
                      <span class="times">&times</span>
                    </template>
                  </ButtonComponent>
                </li>
                <HeaderMenuChildMobComponent v-for="mainNode in menuData" :key="mainNode.id" :main-node="mainNode" />
              </ul>
            </div>
          </div>
        </nav>


        <div id="login-button-container" class="d-flex align-items-center">
          <router-link :to="!store.getters['customer/isLoggedIn'] ? routes.LOGIN : routes.PROFILE"
            :title="store.getters['customer/isLoggedIn'] ? $t('profile') : $t('login')">
            <ButtonComponent class="button-container-white login-button d-none d-lg-flex"
              v-show="parseInt(store.state.socialAuth.enable_login_setting) === 1">
              <template #btnContent>
                <template v-if="!store.getters['customer/isLoggedIn']">
                  {{ $t('login') }}
                </template>
                <template v-else>
                  <template v-if="store.state.customer.company_name">
                    {{ store.state.customer.company_name }}
                  </template>
                  <template v-else>
                    {{ store.state.customer.first_name ?? '' }} {{ store.state.customer.last_name ?? '' }}
                  </template>
                </template>
              </template>
            </ButtonComponent>

            <ButtonComponent class="mob-button-container-white mob-login-button d-lg-none"
              :class="{ 'mob-profile-button': store.getters['customer/isLoggedIn'] }">
              <template #btnContent>
                <font-awesome-icon icon="fa-solid fa-user" />
              </template>
            </ButtonComponent>
          </router-link>
        </div>


      </div>
    </div>

    <!-- Navbar for Mobile and Tablet screen -->
    <!-- <div class="container-fluid-padding mob-menu-display">

      <nav class="navbar navbar-expand-lg pt-0 pb-0 container__tablet-screen">




      </nav>
    </div> -->

  </div>
</template>

<script lang="ts">
import './headerMeniu.scss';
// @ts-ignore
import HeaderMenuChildComponent from './headerMeniuChildren/HeaderMenuChildComponent';
//@ts-ignore
import HeaderMenuChildMobComponent from './headerMeniuChildrenMob/HeaderMenuChildMobComponent';
//@ts-ignore
import HeaderIconValComponent from '../headerIconValComponent/HeaderIconValComponent';
// @ts-ignore
import ButtonComponent from "../../Button/ButtonComponent";
import { routesConst } from "../../../routes";

import { useStore } from "vuex";
import { defineComponent } from "vue";
import type { PropType } from "vue";

interface MenuItem {
  id: string,
  name: string,
  link: string,
  type: string,
  target: string,
  path: string,
  children?: Array<MenuItem[]>
}


export default defineComponent({
  components: {
    HeaderMenuChildComponent,
    HeaderMenuChildMobComponent,
    HeaderIconValComponent,
    ButtonComponent
  },
  props: {
    menuData: {
      type: Array as PropType<MenuItem[]>,
      required: true
    },
  },
  data() {
    return {
      routes: routesConst,
      isOpen: false,
      toggle: true,
    }
  },

  setup() {
    const store = useStore();

    return {
      store,
    };
  },

  methods: {
    toggleMeniu(): void {
      this.isOpen = !this.isOpen
      this.toggle = !this.toggle
    },
  },
})
</script>

<style scoped type="text/css" media="print">
.dont_print {
  display: none !important;
}
</style>